"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePresets = void 0;
var react_1 = require("react");
var defaultPresets = ['50', '100', '200', '500', '1000'];
var usePresets = function (presetOptions) {
    return (0, react_1.useMemo)(function () {
        return (presetOptions || defaultPresets).map(function (el) { return ({
            label: "".concat(el),
            value: "".concat(el),
        }); });
    }, [presetOptions]);
};
exports.usePresets = usePresets;
